import {
  moduleCrudConfig,
  CRUDRoute,
  defaultModuleConfig,
} from './CRUDConfig'
import { CRUD_PATH } from './constants'
import { SERVICES_SCHEMA_NAME } from '../api/services'
import panelConfig from './panelConfig'

export { CRUD_PATH }

export {
  SERVICES_SCHEMA_NAME,
}

const moduleConfig = {
  defaultModuleConfig,
  CRUDRoute,
  CRUD_PATH,
  panelConfig,
  headerConfig: {
    list: {
      title: `Сервисы`,
      path : `/${SERVICES_SCHEMA_NAME}`,
    },
    item: {
      title: `Сервис`,
      path : `/${CRUD_PATH}`,
    },
    entityInfo: {
      name: SERVICES_SCHEMA_NAME,
    },
  },
  moduleCrudConfig,
}

export default moduleConfig
